module.exports = __webpack_public_path__ + "static/media/volya.7334e754.jpg";